import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY, EMPLOYEES_COUNT, OFFICES_COUNT } from 'define';

export const lockUnlockPage = {
  lock: () => {
    document.documentElement.setAttribute('style', 'overflow: hidden;');
  },
  unlock: () => {
    document.documentElement.setAttribute('style', '');
  },
};

export const getEntryPointsFromStorages = point => {
  if (point === 'first') {
    return { firstPoint: window.localStorage.getItem(LOCAL_STORAGE_KEY) };
  }

  if (point === 'session') {
    return { sessionPoint: window.sessionStorage.getItem(SESSION_STORAGE_KEY) };
  }

  return {
    firstPoint: window.localStorage.getItem(LOCAL_STORAGE_KEY),
    sessionPoint: window.sessionStorage.getItem(SESSION_STORAGE_KEY),
  };
};

export const getReferrer = () => {
  const referrer = document.referrer;

  if (!referrer) {
    return 'direct';
  }

  return referrer;
};

export function getCDNUrl(path) {
  return `https://static.andersenlab.com/${path}`;
}

export function distinct(arr) {
  return Object.keys(
    arr.reduce(
      (acc, item) => ({
        ...acc,
        [item.trim()]: true,
      }),
      {},
    ),
  );
}

export function throttle(func, ms, withLastCall = true) {
  let isThrottled = false;
  let savedArgs = null;

  function wrapper(...args) {
    if (isThrottled) {
      savedArgs = args;
      return;
    }

    func(...args);

    isThrottled = true;

    setTimeout(() => {
      isThrottled = false;

      if (withLastCall && savedArgs) {
        wrapper(...savedArgs);
        savedArgs = null;
      }
    }, ms);
  }

  return wrapper;
}

export function debounce(f, ms) {
  let isReadyToExecute = false;

  return function () {
    if (isReadyToExecute) return;

    f.apply(this, arguments);

    isReadyToExecute = true;

    setTimeout(() => (isReadyToExecute = false), ms);
  };
}

export function replaceKeyword(str, specialKey, data) {
  if (typeof str !== 'string') return str;

  const matches = str.matchAll(/{(\w+)}/g);
  let result = str;

  for (const match of matches) {
    if (specialKey && match[1] === specialKey) {
      result = result.replace(match[0], data);
    } else {
      result = result.replace(match[0], checkKeyword);
    }
  }
  return result;
}

function checkKeyword(match) {
  const companyAge = new Date().getFullYear() - new Date(2007, 1, 1).getFullYear();

  switch (match) {
    case '{age}':
      return companyAge;
    case '{employees}':
      return EMPLOYEES_COUNT;
    case '{offices}':
      return OFFICES_COUNT;
    default:
      return match;
  }
}

export const handleFormError = async (data, errorMessage) => {
  const localhost = process.env.NODE_ENV === 'development';

  if (localhost || !data.form) return;

  const gclid = window.localStorage.getItem('gclid');
  const payload = {
    ...data,
    ...getEntryPointsFromStorages(),
    lastPoint: window.location.href,
    referrer: getReferrer(),
    gclid,
    errorMessage,
  };

  if (data.form === 'trainee' || data.form === 'trainee-course') {
    payload.specializations = data.specializations.join('; ');
  }

  await fetch(`${process.env.GATSBY_GOOGLE_SCRIPT_URL}?action=addRow`, {
    method: 'POST',
    body: JSON.stringify(payload),
    redirect: 'follow',
    mode: 'no-cors',
  });
};

export function upperFirst(str) {
  const result = str;
  return result.charAt(0).toUpperCase() + result.slice(1);
}

export function isEmpty(value) {
  return (
    value == null ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  );
}
